import Image from './image';
import ImageBrowser from './image-browser';
Image.Browser = ImageBrowser;
export default Image;